<p class="modal-title">Reedem Promocode</p>
<div class="divider horizontal w-full"></div>
@if (errors().api) {
<div animate.enter="animate-fade-in" class="promo-code--error">
  <svg-icon
    class="promo-code--error--icon"
    src="assets/icons/shared/info.svg"
  />
  <p>{{ errors().api }}</p>
</div>
<div animate.enter="animate-fade-in" class="divider horizontal w-full"></div>
}
<form
  class="promo-code--form flex gap-8 items-center w-full"
  (submit)="$event.preventDefault(); redeemPromocode()"
>
  <app-form-field
    label="Promo Code"
    [errorType]="'outline'"
    [id]="'code'"
    [placeholder]="'Enter Promo Code...'"
    [disabled]="isLoading()"
    [(value)]="code"
    [error]="!!errors().required || !!errors().api"
  />
  <button
    type="submit"
    class="promo-code--button"
    [disabled]="code().trim().length === 0 || isLoading()"
  >
    <app-balance-icon icon="skins" color="var(--black)" />
    Reedem Promocode
  </button>
</form>
